import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "timeline-map-page" }
const _hoisted_2 = { class: "timeline-map-page__view-switch" }

import { computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";

import TimelineMM from "./components/timeline/TimelineMM.vue";
import TimelineJVM from "./components/timeline/TimelineJVM.vue";
import TimelineVRAK from "./components/timeline/TimelineVRAK.vue";
import MapVRAK from './components/map/MapVRAK.vue'
import MomentsList from "./components/moments-list/MomentsList.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineMap',
  setup(__props) {

const store = useTimelineMapStore();
const route = useRoute()
const router = useRouter()

function coerceView(raw: unknown): 'timeline' | 'map' | 'momentsList' | undefined {
  const v = Array.isArray(raw) ? raw[0] : raw
  return v === 'map' || v === 'timeline' || v === 'momentsList' ? v : undefined
}

function setView(view: 'timeline' | 'map' | 'momentsList') {
  router.replace({
    path: route.params.id ? `/${route.params.id}` : '/',
    query: { ...route.query, view }
  })
}

function enforceAllowedView() {
  const v = coerceView(route.query.view)

  const isAllowed =
    v == null ||
    v === 'timeline' ||
    (v === 'map' && store.showMap) ||
    (v === 'momentsList' && store.showMomentsList)

  if (!isAllowed) {
    router.replace({
      path: route.params.id ? `/${route.params.id}` : '/',
      query: { ...route.query, view: undefined },
    })
  }
}

function defaultMapWhenEnabled() {
  const v = coerceView(route.query.view)
  if (store.showMap && v == null) {
    setView('map')
  }
}

onMounted(() => {
  if (store.isMM || store.isVRAK) {
    document.body.classList.add('header-locked');
  }
  if (store.isVRAK) {
    window.scrollTo({ top: 0, behavior: 'auto' })
  }
  enforceAllowedView()
  defaultMapWhenEnabled()
})

onUnmounted(() => {
  if (store.isMM || store.isVRAK) {
    document.body.classList.remove('header-locked');
  }
})

watch(() => [store.showMap, store.showMomentsList], () => {
  if (store.isVRAK) {
    window.scrollTo({ top: 0, behavior: 'auto' })
  }
  enforceAllowedView()
  defaultMapWhenEnabled()
})

// currentView - reads direct from URL
const currentView = computed<'timeline' | 'map' | 'momentsList'>(() => {
  const v = coerceView(route.query.view)
  if (v === 'momentsList') { return 'momentsList' }
  return v === 'map' ? 'map' : 'timeline'
})

const timelineComponent = computed(() => {
  const mapping = { jvm: TimelineJVM, mm: TimelineMM, vrak: TimelineVRAK }
  if (store.isJVM) return mapping.jvm
  if (store.isMM) return mapping.mm
  if (store.isVRAK) return mapping.vrak
  return TimelineMM
})

const mapComponent = computed(() => {
  const mapping = { vrak: MapVRAK }
  if (store.isVRAK) return mapping.vrak
  return TimelineVRAK
})

const currentComponent = computed(() => {
  if (currentView.value === 'map') {
    return mapComponent.value
  }

  if (currentView.value === 'momentsList') {
    return MomentsList
  }

  return timelineComponent.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(store).showMap)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass([
          'timeline-map-page__view-switch-btn',          
          'timeline-map-page__view-switch-btn--map',
          { 'timeline-map-page__view-switch-btn--active': currentView.value === 'map' }
        ]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setView('map')))
          }, _toDisplayString(_unref(store).translations.map), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      (_unref(store).showMomentsList || _unref(store).showMap)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: _normalizeClass([
          'timeline-map-page__view-switch-btn',
          'timeline-map-page__view-switch-btn--timeline',
          { 'timeline-map-page__view-switch-btn--active': currentView.value === 'timeline' }
        ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setView('timeline')))
          }, _toDisplayString(_unref(store).translations.timeline), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      (_unref(store).showMomentsList)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: _normalizeClass([
          'timeline-map-page__view-switch-btn',
          'timeline-map-page__view-switch-btn--moments-list',
          { 'timeline-map-page__view-switch-btn--active': currentView.value === 'momentsList' }
        ]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setView('momentsList')))
          }, _toDisplayString(_unref(store).translations.momentsList), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))
  ]))
}
}

})